import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Typography } from '@mui/material';
import PortalLink from '../common/PortalLink';

const LibraryContacts = ({ contacts }) => (
  <Container id={'universityLibraries__container_campusWrapper'} fluid>
    {contacts.map((contact, index) => (
      <Row
        id={'universityLibraries__row_' + contact.id + 'TextWrapper'}
        className={index ? 'mt-3' : undefined}
        key={'universityLibraries__row_' + contact.id}
      >
        <Col
          id={'universityLibraries__col_' + contact.id + 'TextWrapper'}
          xxl={8}
          xl={12}
          lg={6}
          md={7}
          sm={6}
          xs={12}
          className="text-start px-0"
        >
          <Typography id={'universityLibraries__text_' + contact.id + 'LinkWrapper'} component="h3">
            <PortalLink
              id={'universityLibraries__link_' + contact.id}
              href={contact.link}
              underline={'hover'}
              target="_blank"
              className="noIcon"
            >
              {contact.title}
            </PortalLink>
          </Typography>
          <Typography
            component="h4"
            id={'universityLibraries__text_' + contact.id}
            className={index ? undefined : 'd-block'}
          >
            {contact.subtitle}
          </Typography>
        </Col>

        <Col
          id={'universityLibraries__col_' + contact.id + 'MobileNumberWrapper'}
          xxl={4}
          xl={12}
          lg={6}
          md={5}
          sm={6}
          xs={12}
          className="text-xxl-end text-xl-start text-lg-end text-md-end text-sm-end text-start px-0 "
        >
          <PortalLink
            id={'universityLibraries__link_phone_' + contact.id}
            href={contact.phoneLink}
            underline={'hover'}
            className="myOdu__link phone noIcon"
            aria-label={contact.ariaLabel}
          >
            {contact.phone}
          </PortalLink>
        </Col>
      </Row>
    ))}
  </Container>
);

export default LibraryContacts;
